export default __webpack_public_path__ + "static/media/006-cooking.58047e78.png";